import { render, staticRenderFns } from "./RentalManager.vue?vue&type=template&id=aa6ac4d6"
import script from "./RentalManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./RentalManager.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports